import axios, { AxiosInstance } from 'axios'
import { axiosServiceNowApi } from 'services/Api'
import { IUserWithLocation, User } from 'types/user'
import { ROUTES_NAMES } from 'constants/servicenow.routes'

const UserService = {
    createNewUserWithMultiLocations: async (user:IUserWithLocation):Promise<User> => {
        return axiosServiceNowApi?.post(ROUTES_NAMES.user.post.createWithMultiLocations, user)
    },
    createNewUser: async (user:User):Promise<User> => {
        return axiosServiceNowApi?.post(ROUTES_NAMES.user.post.create, user)
    },
    updateUserBySysIdResource: async (user:IUserWithLocation, sys_id:string):Promise<User> => {
        return axiosServiceNowApi?.put(ROUTES_NAMES.user.put.updateResource(sys_id), user)
    },
    updateUserBySysId: async (user:User, sys_id:string):Promise<User> => {
        return axiosServiceNowApi?.put(ROUTES_NAMES.user.put.update(sys_id), user)
    },
    getUsersManagersByLocationId: async (locationId: string, nome: string,index:number) => {
        const response = await axiosServiceNowApi?.get(ROUTES_NAMES.user.get.by_location_id_and_profile(locationId, 'location_manager'))
        return response ? response.data.result : Promise.resolve([])
    },
    getUsersByAttributeAndValue: async (attribute: string, value: string) => {
        const response = await axiosServiceNowApi?.get(ROUTES_NAMES.user.get.by_attribute_value(attribute, value))
        return response ? response.data.result : Promise.resolve([])
    },
    getAuthenticationUser3: async (accessToken:string) => {

        let res = await axiosServiceNowApi?.post('/auth', { accessToken : accessToken })
        return res
    },
    getAuthenticationUser: async (accessToken:string) => {
        let request = {
            method: 'post',
            body: JSON.stringify({ accessToken : accessToken })
        };
        return await fetch(`${process.env.REACT_APP_PROXY_URL}/auth`, request)
    },
    getSystemUser: async (sysUser: string) => {
        const response = await axiosServiceNowApi?.get(ROUTES_NAMES.user.get.sys_user(sysUser))
        return response ? response.data.result : Promise.resolve([])
    }
}

export default UserService